import React from 'react'

function NotFoundPage() {
  return (
    <div className='flex h-full items-center justify-center'>Тун удахгүй</div>
  )
}

export default NotFoundPage